import { api } from "./api";

export const gmailStatus = () => api.get("/gmail/status").then((r) => r.data);

export const connectGmail = () => {
  const base = window.location.origin;
  window.location.href = `${process.env.REACT_APP_BACKEND_URL}/api/oauth/gmail/login?base=${encodeURIComponent(base)}`;
};

export const sendEmail = (payload) => api.post("/gmail/send", payload).then((r) => r.data);
